<template>
  <v-container class="sticky-cart d-flex align-center justify-space-between" fluid>
    <!-- button -->
    <v-container
      style="width: auto;"
      class="pa-0 ma-0 payment-text d-flex align-center"
      @click="goToCart"
    >
      <v-icon right color="#008542" size="15">mdi-cart-outline</v-icon>
      <v-card-text class="pa-0 ma-0 text-body-2">
        {{ $t("continue peyment") }}
      </v-card-text>
    </v-container>

    <!-- details price -->
    <v-container class="cart-info pa-0 ma-0 d-flex align-center">
      <v-card-text class="pa-0 ma-0 ml-1 text-body-2">{{ totalCount }}</v-card-text>
      <v-card-text class="pa-0 ma-0 ml-1 text-body-2">
        {{ $t("product_item") }}</v-card-text
      >
      <div class="divider"></div>
      <v-card-text class="pa-0 ma-0 total-price"
        >{{ formattedPrice }}
        {{ $store.state.currency.name }}
      </v-card-text>
    </v-container>
  </v-container>
</template>

<script>
export default {
  name: 'StickyCart',
  props: {
    totalCount: {
      type: Number,
      required: true
    },
    totalPrice: {
      type: Number,
      required: true
    }
  },
  computed: {
    formattedPrice () {
      return Number(this.totalPrice).toLocaleString('en-US')
    }
    // totalCount() {
    //   return this.$store.getters.totalCount;
    // },
    // totalPrice() {
    //   const total = this.$store.getters.totalPrice;
    //   return total.toLocaleString("en-US");
    // },
  },
  methods: {
    goToCart () {
      this.$emit('open-cart', true)
    }
  },
  filters: {
    currency (value) {
      if (value == null) return '۰'
      return value.toLocaleString('fa-IR')
    }
  }
}
</script>

<style scoped>
.sticky-cart {
  position: fixed;
  bottom: 18px;
  left: 50%;
  transform: translateX(-50%);
  width: calc(100% - 80px);
  height: 60px;
  max-width: 500px !important;
  background: #fcfcfc;
  border-radius: 12px;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.05), 0 4px 4px rgba(0, 0, 0, 0.25);
  z-index: 2000;
}

.cart-info {
  width: auto;
  font-size: 12px;
  font-weight: 600;
  color: #000;
}
.divider {
  width: 1px;
  height: 18px;
  background-color: #cfcfcf;
  margin: 0 5px;
}
.total-price {
  font-size: 12px;
  font-weight: 700;
}

.payment-text {
  color: #008542;
  cursor: pointer;
  font-weight: 700;
  font-size: 12px;
  transition: 0.25s;
  max-width: 40px;
}
.payment-text:hover {
  opacity: 0.8;
}
.is-disabled {
  pointer-events: none;
  opacity: 0.4;
}
</style>
